import React, { Component, Fragment } from 'react';
import * as Func from '../../../../../../../../helpers/functions';
import * as HMS from "../../../../../../common/component/Index";
import { FlagIcons } from '../../../../../../common/component/TranslateButton';
import { TourTicket } from './../../../../../../../../models/Tour';
import { withTranslation } from "react-i18next";
import { Icon, List, Menu } from 'antd';
import Dropdown from '../../../../../../common/component/Dropdown';
import Modal from '../../../../../../common/component/Modal';
import DEFINE, { PATHS, TRANSLATE_LANGUAGE } from "../../../../../../../../constants/Define";
import * as ANT from 'antd';
import { toArray } from 'lodash';
import EllipsisText from '../../../../../../common/component/EllipsisText';
import i18n from "../../../../../../../../constants/initLng";
import Span from '../../../../../../common/component/Span';
import { Link } from "react-router-dom";

let permisionActions = [];
const ListCols = ['id', 'name', 'propertyToUse', 'code', 'description', 'objectType', 'soldQuantity', 'isAvailable', 'translations'];

const ModelFields = Object.getOwnPropertyNames(new TourTicket());
class TourTicketList extends Component {
    constructor(props) {
        super(props);
        const { t } = this.props;
        this.state = {
            titleTable: Func.getTitleTable(ListCols, ['action'], ['id']),
            modelTourTicket: ModelFields,
            componentTable: {
                name: {
                    key: 'name',
                    title: this.props.t(`item.tourTicket.productName`),
                    width: 200,
                    fixed: 'left',
                    sorter: (i, k) => i.name?.length - k.length,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => <EllipsisText title={record?.name} content={record?.name} contentMaxWidth={170}
                                                            overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
                },
                code: {
                    width: 100
                }, 
                propertyToUse: {
                    width: 250,
                    render: (value, record) => {
                        return value.map(property => (
                            <EllipsisText title={property.name} content={property.name} contentMaxWidth={250}
                                                            overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
                        ))
                    }
                },
                description: {
                    width: 250,
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={200}
                                                            overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
                },
                objectType: {
                    width: 800,
                    render: (text, record) =>
                        <List size="small"
                              dataSource={ record?.tourTicketItems }
                              renderItem={ item =>
                                  <List.Item>
                                      <span className="default-show">
                                        { item?.isDefault && <Icon type="eye" theme="twoTone" /> }
                                      </span>
                                      { `${ item?.multiple } - ${ item?.code } - ${ item?.objectType?.name } - ${ item?.salePrice.toLocaleString() } ${ t(`currency`) }` }
                                      {
                                          item.surchargeCategories.map((item, index, surchargeCategories) => {
                                            if(index === 0) {
                                                return ` | ${item.name} - `
                                            }
                                            if(index === (surchargeCategories.length - 1)) {
                                                return item.name
                                            }
                                            return `${item.name} - `
                                          })
                                      }
                                  </List.Item>
                              }
                        />
                },
                soldQuantity: {
                    key: 'soldQuantity',
                    sorter: (i, k) => i.soldQuantity - k,
                    align: 'right',
                    width: 100,
                },
                // salePrice: {
                //     key: 'salePrice',
                //     align: 'right',
                //     width: 200,
                //     sorter: (i, k) => i.salePrice - k,
                //     render: (salePrice, record) => (
                //         <Span className="prices">
                //             <Span className={record.originalPrice ? "prices-sale" : ''}>{Func.formatMoney(salePrice)}</Span>{`${Func.formatMoney(record.originalPrice)}${this.props.t(`currencySymbol`)}`}
                //         </Span>
                //     )
                // },
                isAvailable: {
                    title: this.props.t('item.tourTicket.available'),
                    key: 'isAvailable',
                    width: 150,
                    render: (status) => <HMS.StatusComponent color={status ? 'green' : 'red'}
                                                             label={status ? i18n.t('item.tourTicket.isAvailable') : i18n.t('item.tourTicket.isUnAvailable')} />,
                    filters: [
                        { value: true, text: this.props.t('item.tourTicket.isAvailable') },
                        { value: false, text: this.props.t('item.tourTicket.isUnAvailable') }
                    ],
                    filterMultiple: false,
                },
                translations: {
                    render: (text, record) => <FlagIcons languages={record.translations} />,
                    key: 'languageCode',
                    width: 120,
                    filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                        value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                    })),
                    filterMultiple: false,
                },
                action: {
                    width: 90,
                    align: 'center',
                    fixed: 'right',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TICKET_SOLD);
    }

    render() {
        const { t, loading, tourTickets, pagination } = this.props;
        const { titleTable, modelTourTicket, componentTable } = this.state;
        return (
            <HMS.ListComponent
                tableKey="table-list-tour-ticket"
                scroll={{ x: 1800 }}
                rowKey={record => record.id}
                loading={{ spinning: loading }}
                dataSource={Func.getDataSource(tourTickets, modelTourTicket)}
                columns={Func.columnsTable({
                    titleTable: titleTable,
                    component: componentTable,
                    itemName: 'tourTicket'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
            />
        );
    }

    renderEditComponent(item) {
        const { t, tour, history } = this.props;
        const removeTourTicket = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onViewCode = () => {
            return this.props.onViewCode && this.props.onViewCode(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.tourTicket.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeTourTicket,
            });
        };
        const onCopy = () => {
            const { confirm } = Modal;
            confirm({
                title: 'Sao chép',
                content: `Bạn có muốn sao chép ${item.name || ''}?`,
                okText: t(`action.confirm`),
                cancelText: t(`action.cancel`),
                onOk: () => history.push(
                    `${Func.getPathWithParams(PATHS.TOUR.TICKET.CREATE.path, { tour_id: tour.id })}?copyFromId=${encodeURIComponent(item.id)}`
                ),
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {/*<Menu.Item className="d-flex align-items-center" onClick={onViewCode}>*/}
                        {/*    <Icon type="eye" className="fs20 mr-1" /> {t(`item.tourTicket.code`)}*/}
                        {/*</Menu.Item>*/}
                        {/*{*/}
                        {/*    permisions && permisions.allowDelete && !!this.props.onDelete &&*/}
                        {/*    <Menu.Item className="d-flex align-items-center" onClick={onRemove}>*/}
                        {/*        <Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}*/}
                        {/*    </Menu.Item>*/}
                        {/*}*/}
                        <Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.TOUR.TICKET.DETAIL.path, { id: item.id, tour_id: tour.id })} className={`mr-2`}>
                                <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                            </Link>
                        </Menu.Item>
                        {
                            this.props.permisions && this.props.permisions.allowCreate &&
                            <Menu.Item className="d-flex align-items-center" onClick={onCopy}>
                                <Icon type="copy" className="fs20 mr-1" /> Sao chép
                            </Menu.Item>
                        }
                        {
                            permisionActions && permisionActions.allowView && item.code && 
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.TICKET_SOLD.LIST_FILTERED_CODE.path, { ticket: `${item.code}...${tour.tourCode}` })} className={`mr-2`}>
                                    <Icon type="eye" className="fs20 mr-1" /> {t(`action.viewListCode`)}
                                </Link>
                            </Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }
}

export default withTranslation()(TourTicketList);
